import {Injectable} from '@angular/core';
import {RegisterDataTableService} from '../../../core/services/register-data-table.service';
import {StorageService} from '../../../core/services/storage.service';
import {ITableColumn} from '../../../core/common/interfaces/table-column.interface';


@Injectable({
  providedIn: 'root'
})
export class OrganizationTableService extends RegisterDataTableService {


  constructor(
    storageService: StorageService
  ) {
    super(storageService);
  }


  override getColumns(): ITableColumn[] {
    return [
      {
        name: 'id',
        title: 'Id',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'iasId',
        title: 'ID ИАС Спорт',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'name',
        title: 'Наименования учреждения',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'organizationGroupName',
        title: 'Группа учреждений',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'objectGroupName',
        title: 'Группа объектов',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'cbTypes',
        title: 'ЦБ',
        default: false,
        useCustomTemplate: false,
      },
      {
        name: 'email',
        title: 'E-mail',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'status',
        title: 'Архив',
        useCustomTemplate: true,
        disabled: false,
        default: false,
      },
    ];
  }


}
